var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2628 5.43896L5.05278 14.129C4.74278 14.459 4.44278 15.109 4.38278 15.559L4.01278 18.799C3.88278 19.969 4.72278 20.769 5.88278 20.569L9.10278 20.019C9.55278 19.939 10.1828 19.609 10.4928 19.269L18.7028 10.579C20.1228 9.07896 20.7628 7.36896 18.5528 5.27896C16.3528 3.20896 14.6828 3.93896 13.2628 5.43896Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8943 6.89056C12.3243 9.65056 14.5643 11.7606 17.3443 12.0406",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlack);
export default __webpack_public_path__ + "static/media/edit-black.d4c6c020e1ea894ebad0cd7f3c898efe.svg";
export { ForwardRef as ReactComponent };